import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface FavItem {
  id: string;
  title: string;
  brand?: string;
  priceGBP: number;
  imageUrl?: string;
  condition?: string;
  originalPriceGBP?: number;
}

interface FavState {
  items: FavItem[];
  toggle: (item: FavItem) => void;
  remove: (id: string) => void;
  clear: () => void;
  has: (id: string) => boolean;
  /** Replace local items with the server's saved list (e.g. after login). */
  hydrate: (items: FavItem[]) => void;
}

/** Saved / liked products. Persisted so likes survive reloads. */
export const useFavourites = create<FavState>()(
  persist(
    (set, get) => ({
      items: [],
      toggle: (item) =>
        set((s) =>
          s.items.some((i) => i.id === item.id)
            ? { items: s.items.filter((i) => i.id !== item.id) }
            : { items: [item, ...s.items] },
        ),
      remove: (id) => set((s) => ({ items: s.items.filter((i) => i.id !== id) })),
      clear: () => set({ items: [] }),
      has: (id) => get().items.some((i) => i.id === id),
      hydrate: (items) => set({ items }),
    }),
    { name: 'souqli-favourites' },
  ),
);
